













import { Vue, Component, Prop } from 'vue-property-decorator';
@Component
export default class MessageInput extends Vue {
  @Prop() value!: any;
  focus() {
    this.$emit('focus');
  }
}
